import script from "./WebArticleList.vue?vue&type=script&setup=true&lang=js"
export * from "./WebArticleList.vue?vue&type=script&setup=true&lang=js"

import "./WebArticleList.vue?vue&type=style&index=0&id=bae9e1e8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bae9e1e8"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerPie from 'quasar/src/components/spinner/QSpinnerPie.js';
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';
import QIntersection from 'quasar/src/components/intersection/QIntersection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QImg,QInput,QIcon,QBtn,QSpinnerPie,QInfiniteScroll,QIntersection,QAvatar});
